/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TokenLoginRouteImport } from './routes/token-login'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedImpersonateRouteImport } from './routes/_authenticated/impersonate'
import { Route as AuthenticatedTestingToolsRouteRouteImport } from './routes/_authenticated/_testing-tools/route'
import { Route as AuthenticatedWorkflowsIndexRouteImport } from './routes/_authenticated/workflows/index'
import { Route as AuthenticatedWorkflowRunsIndexRouteImport } from './routes/_authenticated/workflow-runs/index'
import { Route as AuthenticatedWorkflowOptOutsIndexRouteImport } from './routes/_authenticated/workflow-opt-outs/index'
import { Route as AuthenticatedWorkflowMailroomIndexRouteImport } from './routes/_authenticated/workflow-mailroom/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTestSuitesIndexRouteImport } from './routes/_authenticated/test-suites/index'
import { Route as AuthenticatedPromptTemplatesIndexRouteImport } from './routes/_authenticated/prompt-templates/index'
import { Route as AuthenticatedPetConditionsIndexRouteImport } from './routes/_authenticated/pet-conditions/index'
import { Route as AuthenticatedLlmModelsIndexRouteImport } from './routes/_authenticated/llm-models/index'
import { Route as AuthenticatedGuardrailsIndexRouteImport } from './routes/_authenticated/guardrails/index'
import { Route as AuthenticatedEvalRunsIndexRouteImport } from './routes/_authenticated/eval-runs/index'
import { Route as AuthenticatedEmittersIndexRouteImport } from './routes/_authenticated/emitters/index'
import { Route as AuthenticatedEmitterTemplatesIndexRouteImport } from './routes/_authenticated/emitter-templates/index'
import { Route as AuthenticatedClinicsIndexRouteImport } from './routes/_authenticated/clinics/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedAgentsIndexRouteImport } from './routes/_authenticated/agents/index'
import { Route as AuthenticatedAgentMemoryIndexRouteImport } from './routes/_authenticated/agent-memory/index'
import { Route as AuthenticatedAgentInsightsIndexRouteImport } from './routes/_authenticated/agent-insights/index'
import { Route as AuthenticatedAgentContextDocsIndexRouteImport } from './routes/_authenticated/agent-context-docs/index'
import { Route as AuthenticatedWorkflowsWorkflowIdRouteImport } from './routes/_authenticated/workflows/$workflowId'
import { Route as AuthenticatedWorkflowRunsRunIdRouteImport } from './routes/_authenticated/workflow-runs/$runId'
import { Route as AuthenticatedTestSuitesAddRouteImport } from './routes/_authenticated/test-suites/add'
import { Route as AuthenticatedTestSuitesSuiteIdRouteImport } from './routes/_authenticated/test-suites/$suiteId'
import { Route as AuthenticatedPromptTemplatesAddRouteImport } from './routes/_authenticated/prompt-templates/add'
import { Route as AuthenticatedPromptTemplatesIdRouteImport } from './routes/_authenticated/prompt-templates/$id'
import { Route as AuthenticatedPetConditionsPetIdRouteImport } from './routes/_authenticated/pet-conditions/$petId'
import { Route as AuthenticatedLlmModelsAddRouteImport } from './routes/_authenticated/llm-models/add'
import { Route as AuthenticatedLlmModelsIdRouteImport } from './routes/_authenticated/llm-models/$id'
import { Route as AuthenticatedGuardrailsAddRouteImport } from './routes/_authenticated/guardrails/add'
import { Route as AuthenticatedGuardrailsGuardrailIdRouteImport } from './routes/_authenticated/guardrails/$guardrailId'
import { Route as AuthenticatedEvalRunsRunIdRouteImport } from './routes/_authenticated/eval-runs/$runId'
import { Route as AuthenticatedEmittersReportingRouteImport } from './routes/_authenticated/emitters/reporting'
import { Route as AuthenticatedEmittersExecutionsRouteImport } from './routes/_authenticated/emitters/executions'
import { Route as AuthenticatedEmittersInstanceIdRouteImport } from './routes/_authenticated/emitters/$instanceId'
import { Route as AuthenticatedEmitterTemplatesAddRouteImport } from './routes/_authenticated/emitter-templates/add'
import { Route as AuthenticatedEmitterTemplatesTemplateIdRouteImport } from './routes/_authenticated/emitter-templates/$templateId'
import { Route as AuthenticatedChatsChatIdRouteImport } from './routes/_authenticated/chats/$chatId'
import { Route as AuthenticatedAgentsAddRouteImport } from './routes/_authenticated/agents/add'
import { Route as AuthenticatedAgentsAgentIdRouteImport } from './routes/_authenticated/agents/$agentId'
import { Route as AuthenticatedAgentContextDocsAddRouteImport } from './routes/_authenticated/agent-context-docs/add'
import { Route as AuthenticatedAgentContextDocsIdRouteImport } from './routes/_authenticated/agent-context-docs/$id'
import { Route as AuthenticatedPetConditionsConceptsIndexRouteImport } from './routes/_authenticated/pet-conditions/concepts/index'
import { Route as AuthenticatedEmittersExecutionsIndexRouteImport } from './routes/_authenticated/emitters/executions/index'
import { Route as AuthenticatedEmittersBackfillsIndexRouteImport } from './routes/_authenticated/emitters/backfills/index'
import { Route as AuthenticatedEmitterTemplatesTemplateIdIndexRouteImport } from './routes/_authenticated/emitter-templates/$templateId/index'
import { Route as AuthenticatedTestingToolsBlueprintsIndexRouteImport } from './routes/_authenticated/_testing-tools/blueprints/index'
import { Route as AuthenticatedPetConditionsConceptsConceptIdRouteImport } from './routes/_authenticated/pet-conditions/concepts/$conceptId'
import { Route as AuthenticatedPetConditionsClinicsClinicIdRouteImport } from './routes/_authenticated/pet-conditions/clinics/$clinicId'
import { Route as AuthenticatedEmittersExecutionsExecutionIdRouteImport } from './routes/_authenticated/emitters/executions/$executionId'
import { Route as AuthenticatedEmittersBackfillsLabelRouteImport } from './routes/_authenticated/emitters/backfills/$label'
import { Route as AuthenticatedEmitterTemplatesTemplateIdInstancesRouteImport } from './routes/_authenticated/emitter-templates/$templateId/instances'
import { Route as AuthenticatedTestingToolsBlueprintsBlueprintIdRouteImport } from './routes/_authenticated/_testing-tools/blueprints/$blueprintId'
import { Route as AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRouteImport } from './routes/_authenticated/emitter-templates/$templateId/instances/index'
import { Route as AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRouteImport } from './routes/_authenticated/workflows/$workflowId/tasks/$taskDefId'
import { Route as AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRouteImport } from './routes/_authenticated/test-suites/$suiteId/executions/$executionId'
import { Route as AuthenticatedEvalRunsRunIdReviewConversationIdRouteImport } from './routes/_authenticated/eval-runs/$runId/review/$conversationId'
import { Route as AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteImport } from './routes/_authenticated/emitter-templates/$templateId/instances/$instanceId'
import { Route as AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRouteImport } from './routes/_authenticated/emitter-templates/$templateId/instances/$instanceId/executions'

const TokenLoginRoute = TokenLoginRouteImport.update({
  id: '/token-login',
  path: '/token-login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedImpersonateRoute =
  AuthenticatedImpersonateRouteImport.update({
    id: '/impersonate',
    path: '/impersonate',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTestingToolsRouteRoute =
  AuthenticatedTestingToolsRouteRouteImport.update({
    id: '/_testing-tools',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkflowsIndexRoute =
  AuthenticatedWorkflowsIndexRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkflowRunsIndexRoute =
  AuthenticatedWorkflowRunsIndexRouteImport.update({
    id: '/workflow-runs/',
    path: '/workflow-runs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkflowOptOutsIndexRoute =
  AuthenticatedWorkflowOptOutsIndexRouteImport.update({
    id: '/workflow-opt-outs/',
    path: '/workflow-opt-outs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkflowMailroomIndexRoute =
  AuthenticatedWorkflowMailroomIndexRouteImport.update({
    id: '/workflow-mailroom/',
    path: '/workflow-mailroom/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTestSuitesIndexRoute =
  AuthenticatedTestSuitesIndexRouteImport.update({
    id: '/test-suites/',
    path: '/test-suites/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPromptTemplatesIndexRoute =
  AuthenticatedPromptTemplatesIndexRouteImport.update({
    id: '/prompt-templates/',
    path: '/prompt-templates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPetConditionsIndexRoute =
  AuthenticatedPetConditionsIndexRouteImport.update({
    id: '/pet-conditions/',
    path: '/pet-conditions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLlmModelsIndexRoute =
  AuthenticatedLlmModelsIndexRouteImport.update({
    id: '/llm-models/',
    path: '/llm-models/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGuardrailsIndexRoute =
  AuthenticatedGuardrailsIndexRouteImport.update({
    id: '/guardrails/',
    path: '/guardrails/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEvalRunsIndexRoute =
  AuthenticatedEvalRunsIndexRouteImport.update({
    id: '/eval-runs/',
    path: '/eval-runs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmittersIndexRoute =
  AuthenticatedEmittersIndexRouteImport.update({
    id: '/emitters/',
    path: '/emitters/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmitterTemplatesIndexRoute =
  AuthenticatedEmitterTemplatesIndexRouteImport.update({
    id: '/emitter-templates/',
    path: '/emitter-templates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClinicsIndexRoute =
  AuthenticatedClinicsIndexRouteImport.update({
    id: '/clinics/',
    path: '/clinics/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAgentsIndexRoute =
  AuthenticatedAgentsIndexRouteImport.update({
    id: '/agents/',
    path: '/agents/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentMemoryIndexRoute =
  AuthenticatedAgentMemoryIndexRouteImport.update({
    id: '/agent-memory/',
    path: '/agent-memory/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentInsightsIndexRoute =
  AuthenticatedAgentInsightsIndexRouteImport.update({
    id: '/agent-insights/',
    path: '/agent-insights/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentContextDocsIndexRoute =
  AuthenticatedAgentContextDocsIndexRouteImport.update({
    id: '/agent-context-docs/',
    path: '/agent-context-docs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkflowsWorkflowIdRoute =
  AuthenticatedWorkflowsWorkflowIdRouteImport.update({
    id: '/workflows/$workflowId',
    path: '/workflows/$workflowId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkflowRunsRunIdRoute =
  AuthenticatedWorkflowRunsRunIdRouteImport.update({
    id: '/workflow-runs/$runId',
    path: '/workflow-runs/$runId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTestSuitesAddRoute =
  AuthenticatedTestSuitesAddRouteImport.update({
    id: '/test-suites/add',
    path: '/test-suites/add',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTestSuitesSuiteIdRoute =
  AuthenticatedTestSuitesSuiteIdRouteImport.update({
    id: '/test-suites/$suiteId',
    path: '/test-suites/$suiteId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPromptTemplatesAddRoute =
  AuthenticatedPromptTemplatesAddRouteImport.update({
    id: '/prompt-templates/add',
    path: '/prompt-templates/add',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPromptTemplatesIdRoute =
  AuthenticatedPromptTemplatesIdRouteImport.update({
    id: '/prompt-templates/$id',
    path: '/prompt-templates/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPetConditionsPetIdRoute =
  AuthenticatedPetConditionsPetIdRouteImport.update({
    id: '/pet-conditions/$petId',
    path: '/pet-conditions/$petId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLlmModelsAddRoute =
  AuthenticatedLlmModelsAddRouteImport.update({
    id: '/llm-models/add',
    path: '/llm-models/add',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLlmModelsIdRoute =
  AuthenticatedLlmModelsIdRouteImport.update({
    id: '/llm-models/$id',
    path: '/llm-models/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGuardrailsAddRoute =
  AuthenticatedGuardrailsAddRouteImport.update({
    id: '/guardrails/add',
    path: '/guardrails/add',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGuardrailsGuardrailIdRoute =
  AuthenticatedGuardrailsGuardrailIdRouteImport.update({
    id: '/guardrails/$guardrailId',
    path: '/guardrails/$guardrailId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEvalRunsRunIdRoute =
  AuthenticatedEvalRunsRunIdRouteImport.update({
    id: '/eval-runs/$runId',
    path: '/eval-runs/$runId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmittersReportingRoute =
  AuthenticatedEmittersReportingRouteImport.update({
    id: '/emitters/reporting',
    path: '/emitters/reporting',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmittersExecutionsRoute =
  AuthenticatedEmittersExecutionsRouteImport.update({
    id: '/emitters/executions',
    path: '/emitters/executions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmittersInstanceIdRoute =
  AuthenticatedEmittersInstanceIdRouteImport.update({
    id: '/emitters/$instanceId',
    path: '/emitters/$instanceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmitterTemplatesAddRoute =
  AuthenticatedEmitterTemplatesAddRouteImport.update({
    id: '/emitter-templates/add',
    path: '/emitter-templates/add',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmitterTemplatesTemplateIdRoute =
  AuthenticatedEmitterTemplatesTemplateIdRouteImport.update({
    id: '/emitter-templates/$templateId',
    path: '/emitter-templates/$templateId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsChatIdRoute =
  AuthenticatedChatsChatIdRouteImport.update({
    id: '/chats/$chatId',
    path: '/chats/$chatId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentsAddRoute = AuthenticatedAgentsAddRouteImport.update({
  id: '/agents/add',
  path: '/agents/add',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAgentsAgentIdRoute =
  AuthenticatedAgentsAgentIdRouteImport.update({
    id: '/agents/$agentId',
    path: '/agents/$agentId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentContextDocsAddRoute =
  AuthenticatedAgentContextDocsAddRouteImport.update({
    id: '/agent-context-docs/add',
    path: '/agent-context-docs/add',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentContextDocsIdRoute =
  AuthenticatedAgentContextDocsIdRouteImport.update({
    id: '/agent-context-docs/$id',
    path: '/agent-context-docs/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPetConditionsConceptsIndexRoute =
  AuthenticatedPetConditionsConceptsIndexRouteImport.update({
    id: '/pet-conditions/concepts/',
    path: '/pet-conditions/concepts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmittersExecutionsIndexRoute =
  AuthenticatedEmittersExecutionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEmittersExecutionsRoute,
  } as any)
const AuthenticatedEmittersBackfillsIndexRoute =
  AuthenticatedEmittersBackfillsIndexRouteImport.update({
    id: '/emitters/backfills/',
    path: '/emitters/backfills/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmitterTemplatesTemplateIdIndexRoute =
  AuthenticatedEmitterTemplatesTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEmitterTemplatesTemplateIdRoute,
  } as any)
const AuthenticatedTestingToolsBlueprintsIndexRoute =
  AuthenticatedTestingToolsBlueprintsIndexRouteImport.update({
    id: '/blueprints/',
    path: '/blueprints/',
    getParentRoute: () => AuthenticatedTestingToolsRouteRoute,
  } as any)
const AuthenticatedPetConditionsConceptsConceptIdRoute =
  AuthenticatedPetConditionsConceptsConceptIdRouteImport.update({
    id: '/pet-conditions/concepts/$conceptId',
    path: '/pet-conditions/concepts/$conceptId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPetConditionsClinicsClinicIdRoute =
  AuthenticatedPetConditionsClinicsClinicIdRouteImport.update({
    id: '/pet-conditions/clinics/$clinicId',
    path: '/pet-conditions/clinics/$clinicId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmittersExecutionsExecutionIdRoute =
  AuthenticatedEmittersExecutionsExecutionIdRouteImport.update({
    id: '/$executionId',
    path: '/$executionId',
    getParentRoute: () => AuthenticatedEmittersExecutionsRoute,
  } as any)
const AuthenticatedEmittersBackfillsLabelRoute =
  AuthenticatedEmittersBackfillsLabelRouteImport.update({
    id: '/emitters/backfills/$label',
    path: '/emitters/backfills/$label',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmitterTemplatesTemplateIdInstancesRoute =
  AuthenticatedEmitterTemplatesTemplateIdInstancesRouteImport.update({
    id: '/instances',
    path: '/instances',
    getParentRoute: () => AuthenticatedEmitterTemplatesTemplateIdRoute,
  } as any)
const AuthenticatedTestingToolsBlueprintsBlueprintIdRoute =
  AuthenticatedTestingToolsBlueprintsBlueprintIdRouteImport.update({
    id: '/blueprints/$blueprintId',
    path: '/blueprints/$blueprintId',
    getParentRoute: () => AuthenticatedTestingToolsRouteRoute,
  } as any)
const AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRoute =
  AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEmitterTemplatesTemplateIdInstancesRoute,
  } as any)
const AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRoute =
  AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRouteImport.update({
    id: '/tasks/$taskDefId',
    path: '/tasks/$taskDefId',
    getParentRoute: () => AuthenticatedWorkflowsWorkflowIdRoute,
  } as any)
const AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRoute =
  AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRouteImport.update({
    id: '/executions/$executionId',
    path: '/executions/$executionId',
    getParentRoute: () => AuthenticatedTestSuitesSuiteIdRoute,
  } as any)
const AuthenticatedEvalRunsRunIdReviewConversationIdRoute =
  AuthenticatedEvalRunsRunIdReviewConversationIdRouteImport.update({
    id: '/review/$conversationId',
    path: '/review/$conversationId',
    getParentRoute: () => AuthenticatedEvalRunsRunIdRoute,
  } as any)
const AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRoute =
  AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteImport.update({
    id: '/$instanceId',
    path: '/$instanceId',
    getParentRoute: () => AuthenticatedEmitterTemplatesTemplateIdInstancesRoute,
  } as any)
const AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRoute =
  AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRouteImport.update(
    {
      id: '/executions',
      path: '/executions',
      getParentRoute: () =>
        AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/token-login': typeof TokenLoginRoute
  '/impersonate': typeof AuthenticatedImpersonateRoute
  '/agent-context-docs/$id': typeof AuthenticatedAgentContextDocsIdRoute
  '/agent-context-docs/add': typeof AuthenticatedAgentContextDocsAddRoute
  '/agents/$agentId': typeof AuthenticatedAgentsAgentIdRoute
  '/agents/add': typeof AuthenticatedAgentsAddRoute
  '/chats/$chatId': typeof AuthenticatedChatsChatIdRoute
  '/emitter-templates/$templateId': typeof AuthenticatedEmitterTemplatesTemplateIdRouteWithChildren
  '/emitter-templates/add': typeof AuthenticatedEmitterTemplatesAddRoute
  '/emitters/$instanceId': typeof AuthenticatedEmittersInstanceIdRoute
  '/emitters/executions': typeof AuthenticatedEmittersExecutionsRouteWithChildren
  '/emitters/reporting': typeof AuthenticatedEmittersReportingRoute
  '/eval-runs/$runId': typeof AuthenticatedEvalRunsRunIdRouteWithChildren
  '/guardrails/$guardrailId': typeof AuthenticatedGuardrailsGuardrailIdRoute
  '/guardrails/add': typeof AuthenticatedGuardrailsAddRoute
  '/llm-models/$id': typeof AuthenticatedLlmModelsIdRoute
  '/llm-models/add': typeof AuthenticatedLlmModelsAddRoute
  '/pet-conditions/$petId': typeof AuthenticatedPetConditionsPetIdRoute
  '/prompt-templates/$id': typeof AuthenticatedPromptTemplatesIdRoute
  '/prompt-templates/add': typeof AuthenticatedPromptTemplatesAddRoute
  '/test-suites/$suiteId': typeof AuthenticatedTestSuitesSuiteIdRouteWithChildren
  '/test-suites/add': typeof AuthenticatedTestSuitesAddRoute
  '/workflow-runs/$runId': typeof AuthenticatedWorkflowRunsRunIdRoute
  '/workflows/$workflowId': typeof AuthenticatedWorkflowsWorkflowIdRouteWithChildren
  '/agent-context-docs/': typeof AuthenticatedAgentContextDocsIndexRoute
  '/agent-insights/': typeof AuthenticatedAgentInsightsIndexRoute
  '/agent-memory/': typeof AuthenticatedAgentMemoryIndexRoute
  '/agents/': typeof AuthenticatedAgentsIndexRoute
  '/chats/': typeof AuthenticatedChatsIndexRoute
  '/clinics/': typeof AuthenticatedClinicsIndexRoute
  '/emitter-templates/': typeof AuthenticatedEmitterTemplatesIndexRoute
  '/emitters/': typeof AuthenticatedEmittersIndexRoute
  '/eval-runs/': typeof AuthenticatedEvalRunsIndexRoute
  '/guardrails/': typeof AuthenticatedGuardrailsIndexRoute
  '/llm-models/': typeof AuthenticatedLlmModelsIndexRoute
  '/pet-conditions/': typeof AuthenticatedPetConditionsIndexRoute
  '/prompt-templates/': typeof AuthenticatedPromptTemplatesIndexRoute
  '/test-suites/': typeof AuthenticatedTestSuitesIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/workflow-mailroom/': typeof AuthenticatedWorkflowMailroomIndexRoute
  '/workflow-opt-outs/': typeof AuthenticatedWorkflowOptOutsIndexRoute
  '/workflow-runs/': typeof AuthenticatedWorkflowRunsIndexRoute
  '/workflows/': typeof AuthenticatedWorkflowsIndexRoute
  '/blueprints/$blueprintId': typeof AuthenticatedTestingToolsBlueprintsBlueprintIdRoute
  '/emitter-templates/$templateId/instances': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesRouteWithChildren
  '/emitters/backfills/$label': typeof AuthenticatedEmittersBackfillsLabelRoute
  '/emitters/executions/$executionId': typeof AuthenticatedEmittersExecutionsExecutionIdRoute
  '/pet-conditions/clinics/$clinicId': typeof AuthenticatedPetConditionsClinicsClinicIdRoute
  '/pet-conditions/concepts/$conceptId': typeof AuthenticatedPetConditionsConceptsConceptIdRoute
  '/blueprints/': typeof AuthenticatedTestingToolsBlueprintsIndexRoute
  '/emitter-templates/$templateId/': typeof AuthenticatedEmitterTemplatesTemplateIdIndexRoute
  '/emitters/backfills/': typeof AuthenticatedEmittersBackfillsIndexRoute
  '/emitters/executions/': typeof AuthenticatedEmittersExecutionsIndexRoute
  '/pet-conditions/concepts/': typeof AuthenticatedPetConditionsConceptsIndexRoute
  '/emitter-templates/$templateId/instances/$instanceId': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteWithChildren
  '/eval-runs/$runId/review/$conversationId': typeof AuthenticatedEvalRunsRunIdReviewConversationIdRoute
  '/test-suites/$suiteId/executions/$executionId': typeof AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRoute
  '/workflows/$workflowId/tasks/$taskDefId': typeof AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRoute
  '/emitter-templates/$templateId/instances/': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRoute
  '/emitter-templates/$templateId/instances/$instanceId/executions': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/token-login': typeof TokenLoginRoute
  '/impersonate': typeof AuthenticatedImpersonateRoute
  '/agent-context-docs/$id': typeof AuthenticatedAgentContextDocsIdRoute
  '/agent-context-docs/add': typeof AuthenticatedAgentContextDocsAddRoute
  '/agents/$agentId': typeof AuthenticatedAgentsAgentIdRoute
  '/agents/add': typeof AuthenticatedAgentsAddRoute
  '/chats/$chatId': typeof AuthenticatedChatsChatIdRoute
  '/emitter-templates/add': typeof AuthenticatedEmitterTemplatesAddRoute
  '/emitters/$instanceId': typeof AuthenticatedEmittersInstanceIdRoute
  '/emitters/reporting': typeof AuthenticatedEmittersReportingRoute
  '/eval-runs/$runId': typeof AuthenticatedEvalRunsRunIdRouteWithChildren
  '/guardrails/$guardrailId': typeof AuthenticatedGuardrailsGuardrailIdRoute
  '/guardrails/add': typeof AuthenticatedGuardrailsAddRoute
  '/llm-models/$id': typeof AuthenticatedLlmModelsIdRoute
  '/llm-models/add': typeof AuthenticatedLlmModelsAddRoute
  '/pet-conditions/$petId': typeof AuthenticatedPetConditionsPetIdRoute
  '/prompt-templates/$id': typeof AuthenticatedPromptTemplatesIdRoute
  '/prompt-templates/add': typeof AuthenticatedPromptTemplatesAddRoute
  '/test-suites/$suiteId': typeof AuthenticatedTestSuitesSuiteIdRouteWithChildren
  '/test-suites/add': typeof AuthenticatedTestSuitesAddRoute
  '/workflow-runs/$runId': typeof AuthenticatedWorkflowRunsRunIdRoute
  '/workflows/$workflowId': typeof AuthenticatedWorkflowsWorkflowIdRouteWithChildren
  '/agent-context-docs': typeof AuthenticatedAgentContextDocsIndexRoute
  '/agent-insights': typeof AuthenticatedAgentInsightsIndexRoute
  '/agent-memory': typeof AuthenticatedAgentMemoryIndexRoute
  '/agents': typeof AuthenticatedAgentsIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/clinics': typeof AuthenticatedClinicsIndexRoute
  '/emitter-templates': typeof AuthenticatedEmitterTemplatesIndexRoute
  '/emitters': typeof AuthenticatedEmittersIndexRoute
  '/eval-runs': typeof AuthenticatedEvalRunsIndexRoute
  '/guardrails': typeof AuthenticatedGuardrailsIndexRoute
  '/llm-models': typeof AuthenticatedLlmModelsIndexRoute
  '/pet-conditions': typeof AuthenticatedPetConditionsIndexRoute
  '/prompt-templates': typeof AuthenticatedPromptTemplatesIndexRoute
  '/test-suites': typeof AuthenticatedTestSuitesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/workflow-mailroom': typeof AuthenticatedWorkflowMailroomIndexRoute
  '/workflow-opt-outs': typeof AuthenticatedWorkflowOptOutsIndexRoute
  '/workflow-runs': typeof AuthenticatedWorkflowRunsIndexRoute
  '/workflows': typeof AuthenticatedWorkflowsIndexRoute
  '/blueprints/$blueprintId': typeof AuthenticatedTestingToolsBlueprintsBlueprintIdRoute
  '/emitters/backfills/$label': typeof AuthenticatedEmittersBackfillsLabelRoute
  '/emitters/executions/$executionId': typeof AuthenticatedEmittersExecutionsExecutionIdRoute
  '/pet-conditions/clinics/$clinicId': typeof AuthenticatedPetConditionsClinicsClinicIdRoute
  '/pet-conditions/concepts/$conceptId': typeof AuthenticatedPetConditionsConceptsConceptIdRoute
  '/blueprints': typeof AuthenticatedTestingToolsBlueprintsIndexRoute
  '/emitter-templates/$templateId': typeof AuthenticatedEmitterTemplatesTemplateIdIndexRoute
  '/emitters/backfills': typeof AuthenticatedEmittersBackfillsIndexRoute
  '/emitters/executions': typeof AuthenticatedEmittersExecutionsIndexRoute
  '/pet-conditions/concepts': typeof AuthenticatedPetConditionsConceptsIndexRoute
  '/emitter-templates/$templateId/instances/$instanceId': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteWithChildren
  '/eval-runs/$runId/review/$conversationId': typeof AuthenticatedEvalRunsRunIdReviewConversationIdRoute
  '/test-suites/$suiteId/executions/$executionId': typeof AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRoute
  '/workflows/$workflowId/tasks/$taskDefId': typeof AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRoute
  '/emitter-templates/$templateId/instances': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRoute
  '/emitter-templates/$templateId/instances/$instanceId/executions': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/token-login': typeof TokenLoginRoute
  '/_authenticated/_testing-tools': typeof AuthenticatedTestingToolsRouteRouteWithChildren
  '/_authenticated/impersonate': typeof AuthenticatedImpersonateRoute
  '/_authenticated/agent-context-docs/$id': typeof AuthenticatedAgentContextDocsIdRoute
  '/_authenticated/agent-context-docs/add': typeof AuthenticatedAgentContextDocsAddRoute
  '/_authenticated/agents/$agentId': typeof AuthenticatedAgentsAgentIdRoute
  '/_authenticated/agents/add': typeof AuthenticatedAgentsAddRoute
  '/_authenticated/chats/$chatId': typeof AuthenticatedChatsChatIdRoute
  '/_authenticated/emitter-templates/$templateId': typeof AuthenticatedEmitterTemplatesTemplateIdRouteWithChildren
  '/_authenticated/emitter-templates/add': typeof AuthenticatedEmitterTemplatesAddRoute
  '/_authenticated/emitters/$instanceId': typeof AuthenticatedEmittersInstanceIdRoute
  '/_authenticated/emitters/executions': typeof AuthenticatedEmittersExecutionsRouteWithChildren
  '/_authenticated/emitters/reporting': typeof AuthenticatedEmittersReportingRoute
  '/_authenticated/eval-runs/$runId': typeof AuthenticatedEvalRunsRunIdRouteWithChildren
  '/_authenticated/guardrails/$guardrailId': typeof AuthenticatedGuardrailsGuardrailIdRoute
  '/_authenticated/guardrails/add': typeof AuthenticatedGuardrailsAddRoute
  '/_authenticated/llm-models/$id': typeof AuthenticatedLlmModelsIdRoute
  '/_authenticated/llm-models/add': typeof AuthenticatedLlmModelsAddRoute
  '/_authenticated/pet-conditions/$petId': typeof AuthenticatedPetConditionsPetIdRoute
  '/_authenticated/prompt-templates/$id': typeof AuthenticatedPromptTemplatesIdRoute
  '/_authenticated/prompt-templates/add': typeof AuthenticatedPromptTemplatesAddRoute
  '/_authenticated/test-suites/$suiteId': typeof AuthenticatedTestSuitesSuiteIdRouteWithChildren
  '/_authenticated/test-suites/add': typeof AuthenticatedTestSuitesAddRoute
  '/_authenticated/workflow-runs/$runId': typeof AuthenticatedWorkflowRunsRunIdRoute
  '/_authenticated/workflows/$workflowId': typeof AuthenticatedWorkflowsWorkflowIdRouteWithChildren
  '/_authenticated/agent-context-docs/': typeof AuthenticatedAgentContextDocsIndexRoute
  '/_authenticated/agent-insights/': typeof AuthenticatedAgentInsightsIndexRoute
  '/_authenticated/agent-memory/': typeof AuthenticatedAgentMemoryIndexRoute
  '/_authenticated/agents/': typeof AuthenticatedAgentsIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/clinics/': typeof AuthenticatedClinicsIndexRoute
  '/_authenticated/emitter-templates/': typeof AuthenticatedEmitterTemplatesIndexRoute
  '/_authenticated/emitters/': typeof AuthenticatedEmittersIndexRoute
  '/_authenticated/eval-runs/': typeof AuthenticatedEvalRunsIndexRoute
  '/_authenticated/guardrails/': typeof AuthenticatedGuardrailsIndexRoute
  '/_authenticated/llm-models/': typeof AuthenticatedLlmModelsIndexRoute
  '/_authenticated/pet-conditions/': typeof AuthenticatedPetConditionsIndexRoute
  '/_authenticated/prompt-templates/': typeof AuthenticatedPromptTemplatesIndexRoute
  '/_authenticated/test-suites/': typeof AuthenticatedTestSuitesIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/workflow-mailroom/': typeof AuthenticatedWorkflowMailroomIndexRoute
  '/_authenticated/workflow-opt-outs/': typeof AuthenticatedWorkflowOptOutsIndexRoute
  '/_authenticated/workflow-runs/': typeof AuthenticatedWorkflowRunsIndexRoute
  '/_authenticated/workflows/': typeof AuthenticatedWorkflowsIndexRoute
  '/_authenticated/_testing-tools/blueprints/$blueprintId': typeof AuthenticatedTestingToolsBlueprintsBlueprintIdRoute
  '/_authenticated/emitter-templates/$templateId/instances': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesRouteWithChildren
  '/_authenticated/emitters/backfills/$label': typeof AuthenticatedEmittersBackfillsLabelRoute
  '/_authenticated/emitters/executions/$executionId': typeof AuthenticatedEmittersExecutionsExecutionIdRoute
  '/_authenticated/pet-conditions/clinics/$clinicId': typeof AuthenticatedPetConditionsClinicsClinicIdRoute
  '/_authenticated/pet-conditions/concepts/$conceptId': typeof AuthenticatedPetConditionsConceptsConceptIdRoute
  '/_authenticated/_testing-tools/blueprints/': typeof AuthenticatedTestingToolsBlueprintsIndexRoute
  '/_authenticated/emitter-templates/$templateId/': typeof AuthenticatedEmitterTemplatesTemplateIdIndexRoute
  '/_authenticated/emitters/backfills/': typeof AuthenticatedEmittersBackfillsIndexRoute
  '/_authenticated/emitters/executions/': typeof AuthenticatedEmittersExecutionsIndexRoute
  '/_authenticated/pet-conditions/concepts/': typeof AuthenticatedPetConditionsConceptsIndexRoute
  '/_authenticated/emitter-templates/$templateId/instances/$instanceId': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteWithChildren
  '/_authenticated/eval-runs/$runId/review/$conversationId': typeof AuthenticatedEvalRunsRunIdReviewConversationIdRoute
  '/_authenticated/test-suites/$suiteId/executions/$executionId': typeof AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRoute
  '/_authenticated/workflows/$workflowId/tasks/$taskDefId': typeof AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRoute
  '/_authenticated/emitter-templates/$templateId/instances/': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRoute
  '/_authenticated/emitter-templates/$templateId/instances/$instanceId/executions': typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/token-login'
    | '/impersonate'
    | '/agent-context-docs/$id'
    | '/agent-context-docs/add'
    | '/agents/$agentId'
    | '/agents/add'
    | '/chats/$chatId'
    | '/emitter-templates/$templateId'
    | '/emitter-templates/add'
    | '/emitters/$instanceId'
    | '/emitters/executions'
    | '/emitters/reporting'
    | '/eval-runs/$runId'
    | '/guardrails/$guardrailId'
    | '/guardrails/add'
    | '/llm-models/$id'
    | '/llm-models/add'
    | '/pet-conditions/$petId'
    | '/prompt-templates/$id'
    | '/prompt-templates/add'
    | '/test-suites/$suiteId'
    | '/test-suites/add'
    | '/workflow-runs/$runId'
    | '/workflows/$workflowId'
    | '/agent-context-docs/'
    | '/agent-insights/'
    | '/agent-memory/'
    | '/agents/'
    | '/chats/'
    | '/clinics/'
    | '/emitter-templates/'
    | '/emitters/'
    | '/eval-runs/'
    | '/guardrails/'
    | '/llm-models/'
    | '/pet-conditions/'
    | '/prompt-templates/'
    | '/test-suites/'
    | '/users/'
    | '/workflow-mailroom/'
    | '/workflow-opt-outs/'
    | '/workflow-runs/'
    | '/workflows/'
    | '/blueprints/$blueprintId'
    | '/emitter-templates/$templateId/instances'
    | '/emitters/backfills/$label'
    | '/emitters/executions/$executionId'
    | '/pet-conditions/clinics/$clinicId'
    | '/pet-conditions/concepts/$conceptId'
    | '/blueprints/'
    | '/emitter-templates/$templateId/'
    | '/emitters/backfills/'
    | '/emitters/executions/'
    | '/pet-conditions/concepts/'
    | '/emitter-templates/$templateId/instances/$instanceId'
    | '/eval-runs/$runId/review/$conversationId'
    | '/test-suites/$suiteId/executions/$executionId'
    | '/workflows/$workflowId/tasks/$taskDefId'
    | '/emitter-templates/$templateId/instances/'
    | '/emitter-templates/$templateId/instances/$instanceId/executions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/token-login'
    | '/impersonate'
    | '/agent-context-docs/$id'
    | '/agent-context-docs/add'
    | '/agents/$agentId'
    | '/agents/add'
    | '/chats/$chatId'
    | '/emitter-templates/add'
    | '/emitters/$instanceId'
    | '/emitters/reporting'
    | '/eval-runs/$runId'
    | '/guardrails/$guardrailId'
    | '/guardrails/add'
    | '/llm-models/$id'
    | '/llm-models/add'
    | '/pet-conditions/$petId'
    | '/prompt-templates/$id'
    | '/prompt-templates/add'
    | '/test-suites/$suiteId'
    | '/test-suites/add'
    | '/workflow-runs/$runId'
    | '/workflows/$workflowId'
    | '/agent-context-docs'
    | '/agent-insights'
    | '/agent-memory'
    | '/agents'
    | '/chats'
    | '/clinics'
    | '/emitter-templates'
    | '/emitters'
    | '/eval-runs'
    | '/guardrails'
    | '/llm-models'
    | '/pet-conditions'
    | '/prompt-templates'
    | '/test-suites'
    | '/users'
    | '/workflow-mailroom'
    | '/workflow-opt-outs'
    | '/workflow-runs'
    | '/workflows'
    | '/blueprints/$blueprintId'
    | '/emitters/backfills/$label'
    | '/emitters/executions/$executionId'
    | '/pet-conditions/clinics/$clinicId'
    | '/pet-conditions/concepts/$conceptId'
    | '/blueprints'
    | '/emitter-templates/$templateId'
    | '/emitters/backfills'
    | '/emitters/executions'
    | '/pet-conditions/concepts'
    | '/emitter-templates/$templateId/instances/$instanceId'
    | '/eval-runs/$runId/review/$conversationId'
    | '/test-suites/$suiteId/executions/$executionId'
    | '/workflows/$workflowId/tasks/$taskDefId'
    | '/emitter-templates/$templateId/instances'
    | '/emitter-templates/$templateId/instances/$instanceId/executions'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/token-login'
    | '/_authenticated/_testing-tools'
    | '/_authenticated/impersonate'
    | '/_authenticated/agent-context-docs/$id'
    | '/_authenticated/agent-context-docs/add'
    | '/_authenticated/agents/$agentId'
    | '/_authenticated/agents/add'
    | '/_authenticated/chats/$chatId'
    | '/_authenticated/emitter-templates/$templateId'
    | '/_authenticated/emitter-templates/add'
    | '/_authenticated/emitters/$instanceId'
    | '/_authenticated/emitters/executions'
    | '/_authenticated/emitters/reporting'
    | '/_authenticated/eval-runs/$runId'
    | '/_authenticated/guardrails/$guardrailId'
    | '/_authenticated/guardrails/add'
    | '/_authenticated/llm-models/$id'
    | '/_authenticated/llm-models/add'
    | '/_authenticated/pet-conditions/$petId'
    | '/_authenticated/prompt-templates/$id'
    | '/_authenticated/prompt-templates/add'
    | '/_authenticated/test-suites/$suiteId'
    | '/_authenticated/test-suites/add'
    | '/_authenticated/workflow-runs/$runId'
    | '/_authenticated/workflows/$workflowId'
    | '/_authenticated/agent-context-docs/'
    | '/_authenticated/agent-insights/'
    | '/_authenticated/agent-memory/'
    | '/_authenticated/agents/'
    | '/_authenticated/chats/'
    | '/_authenticated/clinics/'
    | '/_authenticated/emitter-templates/'
    | '/_authenticated/emitters/'
    | '/_authenticated/eval-runs/'
    | '/_authenticated/guardrails/'
    | '/_authenticated/llm-models/'
    | '/_authenticated/pet-conditions/'
    | '/_authenticated/prompt-templates/'
    | '/_authenticated/test-suites/'
    | '/_authenticated/users/'
    | '/_authenticated/workflow-mailroom/'
    | '/_authenticated/workflow-opt-outs/'
    | '/_authenticated/workflow-runs/'
    | '/_authenticated/workflows/'
    | '/_authenticated/_testing-tools/blueprints/$blueprintId'
    | '/_authenticated/emitter-templates/$templateId/instances'
    | '/_authenticated/emitters/backfills/$label'
    | '/_authenticated/emitters/executions/$executionId'
    | '/_authenticated/pet-conditions/clinics/$clinicId'
    | '/_authenticated/pet-conditions/concepts/$conceptId'
    | '/_authenticated/_testing-tools/blueprints/'
    | '/_authenticated/emitter-templates/$templateId/'
    | '/_authenticated/emitters/backfills/'
    | '/_authenticated/emitters/executions/'
    | '/_authenticated/pet-conditions/concepts/'
    | '/_authenticated/emitter-templates/$templateId/instances/$instanceId'
    | '/_authenticated/eval-runs/$runId/review/$conversationId'
    | '/_authenticated/test-suites/$suiteId/executions/$executionId'
    | '/_authenticated/workflows/$workflowId/tasks/$taskDefId'
    | '/_authenticated/emitter-templates/$templateId/instances/'
    | '/_authenticated/emitter-templates/$templateId/instances/$instanceId/executions'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  TokenLoginRoute: typeof TokenLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/token-login': {
      id: '/token-login'
      path: '/token-login'
      fullPath: '/token-login'
      preLoaderRoute: typeof TokenLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/impersonate': {
      id: '/_authenticated/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof AuthenticatedImpersonateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_testing-tools': {
      id: '/_authenticated/_testing-tools'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedTestingToolsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workflows/': {
      id: '/_authenticated/workflows/'
      path: '/workflows'
      fullPath: '/workflows/'
      preLoaderRoute: typeof AuthenticatedWorkflowsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workflow-runs/': {
      id: '/_authenticated/workflow-runs/'
      path: '/workflow-runs'
      fullPath: '/workflow-runs/'
      preLoaderRoute: typeof AuthenticatedWorkflowRunsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workflow-opt-outs/': {
      id: '/_authenticated/workflow-opt-outs/'
      path: '/workflow-opt-outs'
      fullPath: '/workflow-opt-outs/'
      preLoaderRoute: typeof AuthenticatedWorkflowOptOutsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workflow-mailroom/': {
      id: '/_authenticated/workflow-mailroom/'
      path: '/workflow-mailroom'
      fullPath: '/workflow-mailroom/'
      preLoaderRoute: typeof AuthenticatedWorkflowMailroomIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/test-suites/': {
      id: '/_authenticated/test-suites/'
      path: '/test-suites'
      fullPath: '/test-suites/'
      preLoaderRoute: typeof AuthenticatedTestSuitesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/prompt-templates/': {
      id: '/_authenticated/prompt-templates/'
      path: '/prompt-templates'
      fullPath: '/prompt-templates/'
      preLoaderRoute: typeof AuthenticatedPromptTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pet-conditions/': {
      id: '/_authenticated/pet-conditions/'
      path: '/pet-conditions'
      fullPath: '/pet-conditions/'
      preLoaderRoute: typeof AuthenticatedPetConditionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/llm-models/': {
      id: '/_authenticated/llm-models/'
      path: '/llm-models'
      fullPath: '/llm-models/'
      preLoaderRoute: typeof AuthenticatedLlmModelsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/guardrails/': {
      id: '/_authenticated/guardrails/'
      path: '/guardrails'
      fullPath: '/guardrails/'
      preLoaderRoute: typeof AuthenticatedGuardrailsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/eval-runs/': {
      id: '/_authenticated/eval-runs/'
      path: '/eval-runs'
      fullPath: '/eval-runs/'
      preLoaderRoute: typeof AuthenticatedEvalRunsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitters/': {
      id: '/_authenticated/emitters/'
      path: '/emitters'
      fullPath: '/emitters/'
      preLoaderRoute: typeof AuthenticatedEmittersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitter-templates/': {
      id: '/_authenticated/emitter-templates/'
      path: '/emitter-templates'
      fullPath: '/emitter-templates/'
      preLoaderRoute: typeof AuthenticatedEmitterTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/clinics/': {
      id: '/_authenticated/clinics/'
      path: '/clinics'
      fullPath: '/clinics/'
      preLoaderRoute: typeof AuthenticatedClinicsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/': {
      id: '/_authenticated/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthenticatedAgentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agent-memory/': {
      id: '/_authenticated/agent-memory/'
      path: '/agent-memory'
      fullPath: '/agent-memory/'
      preLoaderRoute: typeof AuthenticatedAgentMemoryIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agent-insights/': {
      id: '/_authenticated/agent-insights/'
      path: '/agent-insights'
      fullPath: '/agent-insights/'
      preLoaderRoute: typeof AuthenticatedAgentInsightsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agent-context-docs/': {
      id: '/_authenticated/agent-context-docs/'
      path: '/agent-context-docs'
      fullPath: '/agent-context-docs/'
      preLoaderRoute: typeof AuthenticatedAgentContextDocsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workflows/$workflowId': {
      id: '/_authenticated/workflows/$workflowId'
      path: '/workflows/$workflowId'
      fullPath: '/workflows/$workflowId'
      preLoaderRoute: typeof AuthenticatedWorkflowsWorkflowIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workflow-runs/$runId': {
      id: '/_authenticated/workflow-runs/$runId'
      path: '/workflow-runs/$runId'
      fullPath: '/workflow-runs/$runId'
      preLoaderRoute: typeof AuthenticatedWorkflowRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/test-suites/add': {
      id: '/_authenticated/test-suites/add'
      path: '/test-suites/add'
      fullPath: '/test-suites/add'
      preLoaderRoute: typeof AuthenticatedTestSuitesAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/test-suites/$suiteId': {
      id: '/_authenticated/test-suites/$suiteId'
      path: '/test-suites/$suiteId'
      fullPath: '/test-suites/$suiteId'
      preLoaderRoute: typeof AuthenticatedTestSuitesSuiteIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/prompt-templates/add': {
      id: '/_authenticated/prompt-templates/add'
      path: '/prompt-templates/add'
      fullPath: '/prompt-templates/add'
      preLoaderRoute: typeof AuthenticatedPromptTemplatesAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/prompt-templates/$id': {
      id: '/_authenticated/prompt-templates/$id'
      path: '/prompt-templates/$id'
      fullPath: '/prompt-templates/$id'
      preLoaderRoute: typeof AuthenticatedPromptTemplatesIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pet-conditions/$petId': {
      id: '/_authenticated/pet-conditions/$petId'
      path: '/pet-conditions/$petId'
      fullPath: '/pet-conditions/$petId'
      preLoaderRoute: typeof AuthenticatedPetConditionsPetIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/llm-models/add': {
      id: '/_authenticated/llm-models/add'
      path: '/llm-models/add'
      fullPath: '/llm-models/add'
      preLoaderRoute: typeof AuthenticatedLlmModelsAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/llm-models/$id': {
      id: '/_authenticated/llm-models/$id'
      path: '/llm-models/$id'
      fullPath: '/llm-models/$id'
      preLoaderRoute: typeof AuthenticatedLlmModelsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/guardrails/add': {
      id: '/_authenticated/guardrails/add'
      path: '/guardrails/add'
      fullPath: '/guardrails/add'
      preLoaderRoute: typeof AuthenticatedGuardrailsAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/guardrails/$guardrailId': {
      id: '/_authenticated/guardrails/$guardrailId'
      path: '/guardrails/$guardrailId'
      fullPath: '/guardrails/$guardrailId'
      preLoaderRoute: typeof AuthenticatedGuardrailsGuardrailIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/eval-runs/$runId': {
      id: '/_authenticated/eval-runs/$runId'
      path: '/eval-runs/$runId'
      fullPath: '/eval-runs/$runId'
      preLoaderRoute: typeof AuthenticatedEvalRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitters/reporting': {
      id: '/_authenticated/emitters/reporting'
      path: '/emitters/reporting'
      fullPath: '/emitters/reporting'
      preLoaderRoute: typeof AuthenticatedEmittersReportingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitters/executions': {
      id: '/_authenticated/emitters/executions'
      path: '/emitters/executions'
      fullPath: '/emitters/executions'
      preLoaderRoute: typeof AuthenticatedEmittersExecutionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitters/$instanceId': {
      id: '/_authenticated/emitters/$instanceId'
      path: '/emitters/$instanceId'
      fullPath: '/emitters/$instanceId'
      preLoaderRoute: typeof AuthenticatedEmittersInstanceIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitter-templates/add': {
      id: '/_authenticated/emitter-templates/add'
      path: '/emitter-templates/add'
      fullPath: '/emitter-templates/add'
      preLoaderRoute: typeof AuthenticatedEmitterTemplatesAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitter-templates/$templateId': {
      id: '/_authenticated/emitter-templates/$templateId'
      path: '/emitter-templates/$templateId'
      fullPath: '/emitter-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedEmitterTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/$chatId': {
      id: '/_authenticated/chats/$chatId'
      path: '/chats/$chatId'
      fullPath: '/chats/$chatId'
      preLoaderRoute: typeof AuthenticatedChatsChatIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/add': {
      id: '/_authenticated/agents/add'
      path: '/agents/add'
      fullPath: '/agents/add'
      preLoaderRoute: typeof AuthenticatedAgentsAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/$agentId': {
      id: '/_authenticated/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthenticatedAgentsAgentIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agent-context-docs/add': {
      id: '/_authenticated/agent-context-docs/add'
      path: '/agent-context-docs/add'
      fullPath: '/agent-context-docs/add'
      preLoaderRoute: typeof AuthenticatedAgentContextDocsAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agent-context-docs/$id': {
      id: '/_authenticated/agent-context-docs/$id'
      path: '/agent-context-docs/$id'
      fullPath: '/agent-context-docs/$id'
      preLoaderRoute: typeof AuthenticatedAgentContextDocsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pet-conditions/concepts/': {
      id: '/_authenticated/pet-conditions/concepts/'
      path: '/pet-conditions/concepts'
      fullPath: '/pet-conditions/concepts/'
      preLoaderRoute: typeof AuthenticatedPetConditionsConceptsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitters/executions/': {
      id: '/_authenticated/emitters/executions/'
      path: '/'
      fullPath: '/emitters/executions/'
      preLoaderRoute: typeof AuthenticatedEmittersExecutionsIndexRouteImport
      parentRoute: typeof AuthenticatedEmittersExecutionsRoute
    }
    '/_authenticated/emitters/backfills/': {
      id: '/_authenticated/emitters/backfills/'
      path: '/emitters/backfills'
      fullPath: '/emitters/backfills/'
      preLoaderRoute: typeof AuthenticatedEmittersBackfillsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitter-templates/$templateId/': {
      id: '/_authenticated/emitter-templates/$templateId/'
      path: '/'
      fullPath: '/emitter-templates/$templateId/'
      preLoaderRoute: typeof AuthenticatedEmitterTemplatesTemplateIdIndexRouteImport
      parentRoute: typeof AuthenticatedEmitterTemplatesTemplateIdRoute
    }
    '/_authenticated/_testing-tools/blueprints/': {
      id: '/_authenticated/_testing-tools/blueprints/'
      path: '/blueprints'
      fullPath: '/blueprints/'
      preLoaderRoute: typeof AuthenticatedTestingToolsBlueprintsIndexRouteImport
      parentRoute: typeof AuthenticatedTestingToolsRouteRoute
    }
    '/_authenticated/pet-conditions/concepts/$conceptId': {
      id: '/_authenticated/pet-conditions/concepts/$conceptId'
      path: '/pet-conditions/concepts/$conceptId'
      fullPath: '/pet-conditions/concepts/$conceptId'
      preLoaderRoute: typeof AuthenticatedPetConditionsConceptsConceptIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pet-conditions/clinics/$clinicId': {
      id: '/_authenticated/pet-conditions/clinics/$clinicId'
      path: '/pet-conditions/clinics/$clinicId'
      fullPath: '/pet-conditions/clinics/$clinicId'
      preLoaderRoute: typeof AuthenticatedPetConditionsClinicsClinicIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitters/executions/$executionId': {
      id: '/_authenticated/emitters/executions/$executionId'
      path: '/$executionId'
      fullPath: '/emitters/executions/$executionId'
      preLoaderRoute: typeof AuthenticatedEmittersExecutionsExecutionIdRouteImport
      parentRoute: typeof AuthenticatedEmittersExecutionsRoute
    }
    '/_authenticated/emitters/backfills/$label': {
      id: '/_authenticated/emitters/backfills/$label'
      path: '/emitters/backfills/$label'
      fullPath: '/emitters/backfills/$label'
      preLoaderRoute: typeof AuthenticatedEmittersBackfillsLabelRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emitter-templates/$templateId/instances': {
      id: '/_authenticated/emitter-templates/$templateId/instances'
      path: '/instances'
      fullPath: '/emitter-templates/$templateId/instances'
      preLoaderRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesRouteImport
      parentRoute: typeof AuthenticatedEmitterTemplatesTemplateIdRoute
    }
    '/_authenticated/_testing-tools/blueprints/$blueprintId': {
      id: '/_authenticated/_testing-tools/blueprints/$blueprintId'
      path: '/blueprints/$blueprintId'
      fullPath: '/blueprints/$blueprintId'
      preLoaderRoute: typeof AuthenticatedTestingToolsBlueprintsBlueprintIdRouteImport
      parentRoute: typeof AuthenticatedTestingToolsRouteRoute
    }
    '/_authenticated/emitter-templates/$templateId/instances/': {
      id: '/_authenticated/emitter-templates/$templateId/instances/'
      path: '/'
      fullPath: '/emitter-templates/$templateId/instances/'
      preLoaderRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRouteImport
      parentRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesRoute
    }
    '/_authenticated/workflows/$workflowId/tasks/$taskDefId': {
      id: '/_authenticated/workflows/$workflowId/tasks/$taskDefId'
      path: '/tasks/$taskDefId'
      fullPath: '/workflows/$workflowId/tasks/$taskDefId'
      preLoaderRoute: typeof AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRouteImport
      parentRoute: typeof AuthenticatedWorkflowsWorkflowIdRoute
    }
    '/_authenticated/test-suites/$suiteId/executions/$executionId': {
      id: '/_authenticated/test-suites/$suiteId/executions/$executionId'
      path: '/executions/$executionId'
      fullPath: '/test-suites/$suiteId/executions/$executionId'
      preLoaderRoute: typeof AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRouteImport
      parentRoute: typeof AuthenticatedTestSuitesSuiteIdRoute
    }
    '/_authenticated/eval-runs/$runId/review/$conversationId': {
      id: '/_authenticated/eval-runs/$runId/review/$conversationId'
      path: '/review/$conversationId'
      fullPath: '/eval-runs/$runId/review/$conversationId'
      preLoaderRoute: typeof AuthenticatedEvalRunsRunIdReviewConversationIdRouteImport
      parentRoute: typeof AuthenticatedEvalRunsRunIdRoute
    }
    '/_authenticated/emitter-templates/$templateId/instances/$instanceId': {
      id: '/_authenticated/emitter-templates/$templateId/instances/$instanceId'
      path: '/$instanceId'
      fullPath: '/emitter-templates/$templateId/instances/$instanceId'
      preLoaderRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteImport
      parentRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesRoute
    }
    '/_authenticated/emitter-templates/$templateId/instances/$instanceId/executions': {
      id: '/_authenticated/emitter-templates/$templateId/instances/$instanceId/executions'
      path: '/executions'
      fullPath: '/emitter-templates/$templateId/instances/$instanceId/executions'
      preLoaderRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRouteImport
      parentRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRoute
    }
  }
}

interface AuthenticatedTestingToolsRouteRouteChildren {
  AuthenticatedTestingToolsBlueprintsBlueprintIdRoute: typeof AuthenticatedTestingToolsBlueprintsBlueprintIdRoute
  AuthenticatedTestingToolsBlueprintsIndexRoute: typeof AuthenticatedTestingToolsBlueprintsIndexRoute
}

const AuthenticatedTestingToolsRouteRouteChildren: AuthenticatedTestingToolsRouteRouteChildren =
  {
    AuthenticatedTestingToolsBlueprintsBlueprintIdRoute:
      AuthenticatedTestingToolsBlueprintsBlueprintIdRoute,
    AuthenticatedTestingToolsBlueprintsIndexRoute:
      AuthenticatedTestingToolsBlueprintsIndexRoute,
  }

const AuthenticatedTestingToolsRouteRouteWithChildren =
  AuthenticatedTestingToolsRouteRoute._addFileChildren(
    AuthenticatedTestingToolsRouteRouteChildren,
  )

interface AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteChildren {
  AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRoute
}

const AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteChildren: AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteChildren =
  {
    AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRoute:
      AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdExecutionsRoute,
  }

const AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteWithChildren =
  AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRoute._addFileChildren(
    AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteChildren,
  )

interface AuthenticatedEmitterTemplatesTemplateIdInstancesRouteChildren {
  AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteWithChildren
  AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRoute
}

const AuthenticatedEmitterTemplatesTemplateIdInstancesRouteChildren: AuthenticatedEmitterTemplatesTemplateIdInstancesRouteChildren =
  {
    AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRoute:
      AuthenticatedEmitterTemplatesTemplateIdInstancesInstanceIdRouteWithChildren,
    AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRoute:
      AuthenticatedEmitterTemplatesTemplateIdInstancesIndexRoute,
  }

const AuthenticatedEmitterTemplatesTemplateIdInstancesRouteWithChildren =
  AuthenticatedEmitterTemplatesTemplateIdInstancesRoute._addFileChildren(
    AuthenticatedEmitterTemplatesTemplateIdInstancesRouteChildren,
  )

interface AuthenticatedEmitterTemplatesTemplateIdRouteChildren {
  AuthenticatedEmitterTemplatesTemplateIdInstancesRoute: typeof AuthenticatedEmitterTemplatesTemplateIdInstancesRouteWithChildren
  AuthenticatedEmitterTemplatesTemplateIdIndexRoute: typeof AuthenticatedEmitterTemplatesTemplateIdIndexRoute
}

const AuthenticatedEmitterTemplatesTemplateIdRouteChildren: AuthenticatedEmitterTemplatesTemplateIdRouteChildren =
  {
    AuthenticatedEmitterTemplatesTemplateIdInstancesRoute:
      AuthenticatedEmitterTemplatesTemplateIdInstancesRouteWithChildren,
    AuthenticatedEmitterTemplatesTemplateIdIndexRoute:
      AuthenticatedEmitterTemplatesTemplateIdIndexRoute,
  }

const AuthenticatedEmitterTemplatesTemplateIdRouteWithChildren =
  AuthenticatedEmitterTemplatesTemplateIdRoute._addFileChildren(
    AuthenticatedEmitterTemplatesTemplateIdRouteChildren,
  )

interface AuthenticatedEmittersExecutionsRouteChildren {
  AuthenticatedEmittersExecutionsExecutionIdRoute: typeof AuthenticatedEmittersExecutionsExecutionIdRoute
  AuthenticatedEmittersExecutionsIndexRoute: typeof AuthenticatedEmittersExecutionsIndexRoute
}

const AuthenticatedEmittersExecutionsRouteChildren: AuthenticatedEmittersExecutionsRouteChildren =
  {
    AuthenticatedEmittersExecutionsExecutionIdRoute:
      AuthenticatedEmittersExecutionsExecutionIdRoute,
    AuthenticatedEmittersExecutionsIndexRoute:
      AuthenticatedEmittersExecutionsIndexRoute,
  }

const AuthenticatedEmittersExecutionsRouteWithChildren =
  AuthenticatedEmittersExecutionsRoute._addFileChildren(
    AuthenticatedEmittersExecutionsRouteChildren,
  )

interface AuthenticatedEvalRunsRunIdRouteChildren {
  AuthenticatedEvalRunsRunIdReviewConversationIdRoute: typeof AuthenticatedEvalRunsRunIdReviewConversationIdRoute
}

const AuthenticatedEvalRunsRunIdRouteChildren: AuthenticatedEvalRunsRunIdRouteChildren =
  {
    AuthenticatedEvalRunsRunIdReviewConversationIdRoute:
      AuthenticatedEvalRunsRunIdReviewConversationIdRoute,
  }

const AuthenticatedEvalRunsRunIdRouteWithChildren =
  AuthenticatedEvalRunsRunIdRoute._addFileChildren(
    AuthenticatedEvalRunsRunIdRouteChildren,
  )

interface AuthenticatedTestSuitesSuiteIdRouteChildren {
  AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRoute: typeof AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRoute
}

const AuthenticatedTestSuitesSuiteIdRouteChildren: AuthenticatedTestSuitesSuiteIdRouteChildren =
  {
    AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRoute:
      AuthenticatedTestSuitesSuiteIdExecutionsExecutionIdRoute,
  }

const AuthenticatedTestSuitesSuiteIdRouteWithChildren =
  AuthenticatedTestSuitesSuiteIdRoute._addFileChildren(
    AuthenticatedTestSuitesSuiteIdRouteChildren,
  )

interface AuthenticatedWorkflowsWorkflowIdRouteChildren {
  AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRoute: typeof AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRoute
}

const AuthenticatedWorkflowsWorkflowIdRouteChildren: AuthenticatedWorkflowsWorkflowIdRouteChildren =
  {
    AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRoute:
      AuthenticatedWorkflowsWorkflowIdTasksTaskDefIdRoute,
  }

const AuthenticatedWorkflowsWorkflowIdRouteWithChildren =
  AuthenticatedWorkflowsWorkflowIdRoute._addFileChildren(
    AuthenticatedWorkflowsWorkflowIdRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedTestingToolsRouteRoute: typeof AuthenticatedTestingToolsRouteRouteWithChildren
  AuthenticatedImpersonateRoute: typeof AuthenticatedImpersonateRoute
  AuthenticatedAgentContextDocsIdRoute: typeof AuthenticatedAgentContextDocsIdRoute
  AuthenticatedAgentContextDocsAddRoute: typeof AuthenticatedAgentContextDocsAddRoute
  AuthenticatedAgentsAgentIdRoute: typeof AuthenticatedAgentsAgentIdRoute
  AuthenticatedAgentsAddRoute: typeof AuthenticatedAgentsAddRoute
  AuthenticatedChatsChatIdRoute: typeof AuthenticatedChatsChatIdRoute
  AuthenticatedEmitterTemplatesTemplateIdRoute: typeof AuthenticatedEmitterTemplatesTemplateIdRouteWithChildren
  AuthenticatedEmitterTemplatesAddRoute: typeof AuthenticatedEmitterTemplatesAddRoute
  AuthenticatedEmittersInstanceIdRoute: typeof AuthenticatedEmittersInstanceIdRoute
  AuthenticatedEmittersExecutionsRoute: typeof AuthenticatedEmittersExecutionsRouteWithChildren
  AuthenticatedEmittersReportingRoute: typeof AuthenticatedEmittersReportingRoute
  AuthenticatedEvalRunsRunIdRoute: typeof AuthenticatedEvalRunsRunIdRouteWithChildren
  AuthenticatedGuardrailsGuardrailIdRoute: typeof AuthenticatedGuardrailsGuardrailIdRoute
  AuthenticatedGuardrailsAddRoute: typeof AuthenticatedGuardrailsAddRoute
  AuthenticatedLlmModelsIdRoute: typeof AuthenticatedLlmModelsIdRoute
  AuthenticatedLlmModelsAddRoute: typeof AuthenticatedLlmModelsAddRoute
  AuthenticatedPetConditionsPetIdRoute: typeof AuthenticatedPetConditionsPetIdRoute
  AuthenticatedPromptTemplatesIdRoute: typeof AuthenticatedPromptTemplatesIdRoute
  AuthenticatedPromptTemplatesAddRoute: typeof AuthenticatedPromptTemplatesAddRoute
  AuthenticatedTestSuitesSuiteIdRoute: typeof AuthenticatedTestSuitesSuiteIdRouteWithChildren
  AuthenticatedTestSuitesAddRoute: typeof AuthenticatedTestSuitesAddRoute
  AuthenticatedWorkflowRunsRunIdRoute: typeof AuthenticatedWorkflowRunsRunIdRoute
  AuthenticatedWorkflowsWorkflowIdRoute: typeof AuthenticatedWorkflowsWorkflowIdRouteWithChildren
  AuthenticatedAgentContextDocsIndexRoute: typeof AuthenticatedAgentContextDocsIndexRoute
  AuthenticatedAgentInsightsIndexRoute: typeof AuthenticatedAgentInsightsIndexRoute
  AuthenticatedAgentMemoryIndexRoute: typeof AuthenticatedAgentMemoryIndexRoute
  AuthenticatedAgentsIndexRoute: typeof AuthenticatedAgentsIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedClinicsIndexRoute: typeof AuthenticatedClinicsIndexRoute
  AuthenticatedEmitterTemplatesIndexRoute: typeof AuthenticatedEmitterTemplatesIndexRoute
  AuthenticatedEmittersIndexRoute: typeof AuthenticatedEmittersIndexRoute
  AuthenticatedEvalRunsIndexRoute: typeof AuthenticatedEvalRunsIndexRoute
  AuthenticatedGuardrailsIndexRoute: typeof AuthenticatedGuardrailsIndexRoute
  AuthenticatedLlmModelsIndexRoute: typeof AuthenticatedLlmModelsIndexRoute
  AuthenticatedPetConditionsIndexRoute: typeof AuthenticatedPetConditionsIndexRoute
  AuthenticatedPromptTemplatesIndexRoute: typeof AuthenticatedPromptTemplatesIndexRoute
  AuthenticatedTestSuitesIndexRoute: typeof AuthenticatedTestSuitesIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedWorkflowMailroomIndexRoute: typeof AuthenticatedWorkflowMailroomIndexRoute
  AuthenticatedWorkflowOptOutsIndexRoute: typeof AuthenticatedWorkflowOptOutsIndexRoute
  AuthenticatedWorkflowRunsIndexRoute: typeof AuthenticatedWorkflowRunsIndexRoute
  AuthenticatedWorkflowsIndexRoute: typeof AuthenticatedWorkflowsIndexRoute
  AuthenticatedEmittersBackfillsLabelRoute: typeof AuthenticatedEmittersBackfillsLabelRoute
  AuthenticatedPetConditionsClinicsClinicIdRoute: typeof AuthenticatedPetConditionsClinicsClinicIdRoute
  AuthenticatedPetConditionsConceptsConceptIdRoute: typeof AuthenticatedPetConditionsConceptsConceptIdRoute
  AuthenticatedEmittersBackfillsIndexRoute: typeof AuthenticatedEmittersBackfillsIndexRoute
  AuthenticatedPetConditionsConceptsIndexRoute: typeof AuthenticatedPetConditionsConceptsIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedTestingToolsRouteRoute:
    AuthenticatedTestingToolsRouteRouteWithChildren,
  AuthenticatedImpersonateRoute: AuthenticatedImpersonateRoute,
  AuthenticatedAgentContextDocsIdRoute: AuthenticatedAgentContextDocsIdRoute,
  AuthenticatedAgentContextDocsAddRoute: AuthenticatedAgentContextDocsAddRoute,
  AuthenticatedAgentsAgentIdRoute: AuthenticatedAgentsAgentIdRoute,
  AuthenticatedAgentsAddRoute: AuthenticatedAgentsAddRoute,
  AuthenticatedChatsChatIdRoute: AuthenticatedChatsChatIdRoute,
  AuthenticatedEmitterTemplatesTemplateIdRoute:
    AuthenticatedEmitterTemplatesTemplateIdRouteWithChildren,
  AuthenticatedEmitterTemplatesAddRoute: AuthenticatedEmitterTemplatesAddRoute,
  AuthenticatedEmittersInstanceIdRoute: AuthenticatedEmittersInstanceIdRoute,
  AuthenticatedEmittersExecutionsRoute:
    AuthenticatedEmittersExecutionsRouteWithChildren,
  AuthenticatedEmittersReportingRoute: AuthenticatedEmittersReportingRoute,
  AuthenticatedEvalRunsRunIdRoute: AuthenticatedEvalRunsRunIdRouteWithChildren,
  AuthenticatedGuardrailsGuardrailIdRoute:
    AuthenticatedGuardrailsGuardrailIdRoute,
  AuthenticatedGuardrailsAddRoute: AuthenticatedGuardrailsAddRoute,
  AuthenticatedLlmModelsIdRoute: AuthenticatedLlmModelsIdRoute,
  AuthenticatedLlmModelsAddRoute: AuthenticatedLlmModelsAddRoute,
  AuthenticatedPetConditionsPetIdRoute: AuthenticatedPetConditionsPetIdRoute,
  AuthenticatedPromptTemplatesIdRoute: AuthenticatedPromptTemplatesIdRoute,
  AuthenticatedPromptTemplatesAddRoute: AuthenticatedPromptTemplatesAddRoute,
  AuthenticatedTestSuitesSuiteIdRoute:
    AuthenticatedTestSuitesSuiteIdRouteWithChildren,
  AuthenticatedTestSuitesAddRoute: AuthenticatedTestSuitesAddRoute,
  AuthenticatedWorkflowRunsRunIdRoute: AuthenticatedWorkflowRunsRunIdRoute,
  AuthenticatedWorkflowsWorkflowIdRoute:
    AuthenticatedWorkflowsWorkflowIdRouteWithChildren,
  AuthenticatedAgentContextDocsIndexRoute:
    AuthenticatedAgentContextDocsIndexRoute,
  AuthenticatedAgentInsightsIndexRoute: AuthenticatedAgentInsightsIndexRoute,
  AuthenticatedAgentMemoryIndexRoute: AuthenticatedAgentMemoryIndexRoute,
  AuthenticatedAgentsIndexRoute: AuthenticatedAgentsIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedClinicsIndexRoute: AuthenticatedClinicsIndexRoute,
  AuthenticatedEmitterTemplatesIndexRoute:
    AuthenticatedEmitterTemplatesIndexRoute,
  AuthenticatedEmittersIndexRoute: AuthenticatedEmittersIndexRoute,
  AuthenticatedEvalRunsIndexRoute: AuthenticatedEvalRunsIndexRoute,
  AuthenticatedGuardrailsIndexRoute: AuthenticatedGuardrailsIndexRoute,
  AuthenticatedLlmModelsIndexRoute: AuthenticatedLlmModelsIndexRoute,
  AuthenticatedPetConditionsIndexRoute: AuthenticatedPetConditionsIndexRoute,
  AuthenticatedPromptTemplatesIndexRoute:
    AuthenticatedPromptTemplatesIndexRoute,
  AuthenticatedTestSuitesIndexRoute: AuthenticatedTestSuitesIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedWorkflowMailroomIndexRoute:
    AuthenticatedWorkflowMailroomIndexRoute,
  AuthenticatedWorkflowOptOutsIndexRoute:
    AuthenticatedWorkflowOptOutsIndexRoute,
  AuthenticatedWorkflowRunsIndexRoute: AuthenticatedWorkflowRunsIndexRoute,
  AuthenticatedWorkflowsIndexRoute: AuthenticatedWorkflowsIndexRoute,
  AuthenticatedEmittersBackfillsLabelRoute:
    AuthenticatedEmittersBackfillsLabelRoute,
  AuthenticatedPetConditionsClinicsClinicIdRoute:
    AuthenticatedPetConditionsClinicsClinicIdRoute,
  AuthenticatedPetConditionsConceptsConceptIdRoute:
    AuthenticatedPetConditionsConceptsConceptIdRoute,
  AuthenticatedEmittersBackfillsIndexRoute:
    AuthenticatedEmittersBackfillsIndexRoute,
  AuthenticatedPetConditionsConceptsIndexRoute:
    AuthenticatedPetConditionsConceptsIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  TokenLoginRoute: TokenLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
